/* State module for entities information, shared across the app. If a page needs to store specific information, use a module for the given page. */

// Mutations and Actions
import BaseModule from '@/store/baseModule';
import entitiesRequest from '@/business/apiTreatment/request/entitiesRequest';
import BaseModulePlugins from '@/store/baseModule/plugins';
import EntitiesService from '@/services/services/entities.service';
import registerTopLevelEntities from './top-level';
import registerTopLevelBasket from './basket';

export default (store) => {
  store.registerModule(
    'entities',
    new BaseModule({
      serviceAPI: EntitiesService,
      makeQueryParams: entitiesRequest,
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'entities',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.persistVuexMutationsToLocalStorage(['SET_CURRENT']);
  });
  registerTopLevelEntities(store);
  registerTopLevelBasket(store);
};
